export default class CashierCheckout {
  constructor(props) {
    this.props = props;

    this.el = $('#CashierCheckout-Component');
    if (!this.el.length) { return false; }


    this.searchCustomerNr = this.el.find('#cashier_search_customernumber');
    this.searchLastname = this.el.find('#cashier_search_lastname');
    this.searchFirstname = this.el.find('#cashier_search_firstname');
    this.searchEmail= this.el.find('#cashier_search_email');
    this.searchPhone = this.el.find('#cashier_search_phone');
    this.selectCustomerForm = this.el.find('#select-customer-form');
    this.finalForm = this.el.find('#final_form');
    this.backBtn = this.el.find('#cashier_backbtn');
    this.cntHits = this.el.find('#cntHits');


    this.searchResultListTable = this.el.find('#cashier_search_result_table');
    this.searchResultList = this.el.find('#cashier_search_result');
    this.btnShowCustomer = this.el.find('.btnShowCustomer');


    // MODAL
    this.customerFirstname = this.el.find('#customer_firstname');
    this.customerLastname  = this.el.find('#customer_lastname');
    this.customerEmail  = this.el.find('#customer_email');
    this.customerPhone  = this.el.find('#customer_phone');
    this.customerAddress  = this.el.find('#customer_address');
    this.customerAddress2  = this.el.find('#customer_address2');
    this.customerZipCode  = this.el.find('#customer_zipcode');
    this.customerCity  = this.el.find('#customer_city');
    this.customerCountry  = this.el.find('#customer_country');
    this.customerPhone2  = this.el.find('#customer_phone2');


    this.modalTitle = this.el.find('#CashierCheckout-Component-modal-title');
    this.btnCreateNewCustomer = this.el.find('#CashierCheckout-Component-btnCreateNewCustomer');
    this.modalAddCustomer = this.el.find('#CashierCheckout-Component-addcustomer-modal');

    this.btnModalMsg = this.el.find('#CashierCheckout-Component-addcustomer-modal-messageblock');
    this.pnlModalUserExist = this.el.find('#CashierCheckout-Component-addcustomer-modal-userexists');
    this.btnModalUserExistSearch = this.el.find('#CashierCheckout-Component-addcustomer-modal-search');


    this.btnModalClose = this.el.find('.close');
    this.btnModalCancel = this.el.find('#CashierCheckout-Component-addcustomer-modal-cancel');
    this.btnModalSubmit = this.el.find('#CashierCheckout-Component-addcustomer-modal-submit');
    this.btnModalEditSubmit = this.el.find('#CashierCheckout-Component-editcustomer-modal-submit');

    // this.finalForm.hide();
    // select-customer-form
    this.searchResultList = this.el.find('#cashier_search_result');
    this.btnShowCustomer = this.el.find('.btnShowCustomer');


    // BINDNINGS //
    this._search = this._search.bind(this);
    this._searchCall = this._searchCall.bind(this);
    //this._searchFilter = this._searchFilter.bind(this);
    this._back = this._back.bind(this);
    //this._selectCustomer = this._selectCustomer.bind(this);
    this._btnCreateNewCustomer = this._btnCreateNewCustomer.bind(this);
    this._btnShowCustomer = this._btnShowCustomer.bind(this);
    this._btnCustomerModalCancel = this._btnCustomerModalCancel.bind(this);
    this._btnCustomerModalSubmit = this._btnCustomerModalSubmit.bind(this);
    this._btnCustomerModalEditSubmit = this._btnCustomerModalEditSubmit.bind(this);
    this._btnCustomerModalExistSearch = this._btnCustomerModalExistSearch.bind(this);
    //this.searchName.addEventListener('onpropertychange', ev => this.search())

    // EVENTS //
    this.eventFirstname = this.searchFirstname.keyup(this._search);
    this.eventLastname = this.searchLastname.keyup(this._search);
    this.eventEmail = this.searchEmail.keyup(this._search);
    this.eventPhone = this.searchPhone.keyup(this._search);
    this.eventCustomerNr = this.searchCustomerNr.keyup(this._search);

    //btn-cashier-pick

    //this.el.on('click', '.btn-cashier-pick', this._selectCustomer);
    this.backBtn.on('click', this._back);
    this.btnCreateNewCustomer.on('click', this._btnCreateNewCustomer);

    this.searchResultList.on('click','.btnShowCustomer', this._btnShowCustomer);
    //$(document).on('click', '#btnPrepend', function () {//do something})
    // this.btnShowCustomer.on('click', this._btnCreateNewCustomer);
    this.btnModalCancel.on('click', this._btnCustomerModalCancel);
    this.btnModalClose.on('click', this._btnCustomerModalCancel);
    this.btnModalSubmit.on('click', this._btnCustomerModalSubmit);
    this.btnModalEditSubmit.on('click', this._btnCustomerModalEditSubmit);
    this.btnModalUserExistSearch.on('click', this._btnCustomerModalExistSearch);


    this.searchT = null;

  }

  _back() {
    this.finalForm.hide();
    this.selectCustomerForm.fadeIn();
  }

  //_searchFilter(obj) {
  //  var searchFirstname = this.searchFirstname.val();
  //  var searchLastname = this.searchLastname.val();
  //  var searchEmail = this.searchEmail.val();
  //  var searchMob = this.searchMobile.val();

  //  var reFirstname = new RegExp(searchFirstname, 'i');
  //  //var reLastname = new RegExp(searchLastname, 'i');
  //  var reEmail = new RegExp(searchEmail, 'i');
  //  var reMob = new RegExp(searchMob, 'i');
  //  return ((!searchFirstname || reFirstname.test(obj.kundnummer)) &&
  //    (!searchMob || reMob.test(obj.Mob)) &&
  //    (!searchEmail || reEmail.test(obj.email)) );
  //};

  _search() {
    if (this.searchT!=null) clearTimeout(this.searchT);
    this.searchT = setTimeout(this._searchCall, 500);
  }

  _searchDrawTable(data) {

  }
  _searchCall() {
    this.cntHits.html("");
    this.searchResultList.html("");
    this.searchResultListTable.hide();
    if (this.searchLastname.val().length >= 3 || this.searchFirstname.val().length >= 3 || this.searchEmail.val().length >= 3 || this.searchPhone.val().length >= 5 || this.searchCustomerNr.val().length>=3 ) {
      var _this = this;
      $.ajax({
        url: "/Cashier/SearchContacts",
        type: 'POST',
        data: jQuery.param({ email: _this.searchEmail.val(), firstname: _this.searchFirstname.val(), lastname: _this.searchLastname.val(), phone: _this.searchPhone.val(), customernumber: _this.searchCustomerNr.val() }),
        error: function () {
          _this.searchResultList.html("");
          _this.searchResultList.html('<p>An error has occurred</p>');
          _this.searchResultList.fadeIn();
        },
        //dataType: 'jsonp',
        success: function (datan) {
          _this.data = datan;
          if (datan.length >= 50) {
            _this.cntHits.html("50+");
          } else {
            _this.cntHits.html(datan.length);
          }
          _this.searchResultList.html("");

          for (var i = 0; i < datan.length; i++) {
            _this.searchResultList.append("<tr>" +
              "<td class=\"\"><a class=\"btn btn-border btnShowCustomer\" data-id=\"" + datan[i].id + "\"><i class='ico ico-edit'></i> " + datan[i].id + "</a></td>" +
              "<td class=\" col-text\">" + datan[i].firstname + " " + datan[i].lastname + "</td>" +
              "<td class=\" col-text\">" + datan[i].email + "</td>" +
              "<td class=\" col-text\">" + _this._formatPhone(datan[i].mobile, datan[i].phone) + "</td>" +
              "<td class=\"\"><form method=post action=\"/Cashier/setcustomer\"><input id=\"customerid\" name=\"customerid\" type=hidden value=\"" + datan[i].id + "\"><button type=submit class=\"link-btn-regular btn-cashier-pick\" id=\"cash_" + datan[i].id + "\" data-id=\"" + datan[i].id + "\">Välj</button></form></td>" +
              "</tr>");
          }
          _this.searchResultListTable.fadeIn();
          _this.searchResultList.fadeIn();


          var bodyRect = document.body.getBoundingClientRect();
          var elemRect = _this.searchResultList[0].getBoundingClientRect();
          var offset = elemRect.top - bodyRect.top;
          window.scrollTo({ top: offset-120, behavior: 'smooth', });

        }
      });


      

     
      //var datan = this.data.filter(function (el) { return _this._searchFilter(el); });
      //this.searchResultList.html("");
      //this.searchResultList.append("Sökresultat: " + datan.length + "...<br/>");
      //for (var i = 0; i < datan.length; i++) {
      //  this.searchResultList.append("<div class=\"row result-row align-items-center\"><div class=\"col-2\"><form method=post action=\"/Cashier/setcustomer\"><input id=\"customerid\" name=\"customerid\" type=hidden value=\"" + datan[i].id + "\"><button type=submit class=\"btn link-btn-regular btn-cashier-pick\" id=\"cash_" + datan[i].id + "\" data-id=\"" + datan[i].id + "\">Välj</button></form></div><div class=\"col\">" + datan[i].kundnummer + "</div><div class=\"col\">" + datan[i].Name + "</div><div class=\"col\">" + datan[i].email + "</div><div class=\"col\">" + datan[i].Mob + "</div></div>");
      //}
      //this.searchResultList.fadeIn();
      this.searchT = null;
    } else {
      this.searchResultList.fadeOut();
    }
  }


  _formatPhone(mob, phone) {
    var result = "";
    if (mob != null && mob != "null") {
      result = mob;
    } else if (phone != null && phone != "null")
    {
      result = phone;
    }
    return result;
  }

  //  _selectCustomer(btn, el) {
  //  //this.finalForm.fadeIn(200);
  //  //this.selectCustomerForm.hide();

  //  console.log(btn, btn.currentTarget.dataset["id"]);
  //  var id = btn.currentTarget.dataset["id"];
  //  var customer = this.data.filter(function (el) { return el.id == id; })[0];
  //  console.log(customer);
  //  // Yabie_name
  //  //$("#Yabie_name").val(customer.Name);
  //}




  //
  // EDIT //////////////////////////
  //

  _btnShowCustomer(e) {
    console.log("edit customer", e);
    this.btnModalEditSubmit.show();
    this.btnModalSubmit.hide();
    this.btnModalMsg.hide();
    this.pnlModalUserExist.hide();
    const edit_id = e.currentTarget.dataset.id;
    this.modalTitle[0].innerText = "Redigera kund: " + edit_id;


    let _this = this;
    $.ajax({
      url: "/Cashier/GetCustomer",
      type: 'POST',
      data: jQuery.param({ customerId: edit_id }),
      error: function () {
        _this.btnModalMsg.fadeIn();
        _this.modalAddCustomer.show();
      },
      success: function (data) {
        if (data.id > 0) {
          _this.editCustomerId = edit_id;
          _this.customerFirstname.val(data.firstName);
          _this.customerLastname.val(data.lastName);
          _this.customerEmail.val(data.email);
          _this.customerPhone.val(data.phone);
          _this.customerAddress.val(data.address);
          _this.customerAddress2.val(data.address2);
          _this.customerZipCode.val(data.postcode);
          _this.customerCity.val(data.city);
          _this.customerCountry.val(data.country);
          _this.customerPhone2.val(data.mobile);

          _this.modalAddCustomer.show();

        } else {
          _this.btnModalMsg.fadeIn();
          _this.modalAddCustomer.show();
        }
      }
    });

  }


  _btnCustomerModalEditSubmit() {

    var _this = this;
    var data = jQuery.param({
      Id: _this.editCustomerId,
      FirstName: _this.customerFirstname.val(),
      LastName: _this.customerLastname.val(),
      Email: _this.customerEmail.val(),
      Phone: _this.customerPhone.val(),
      Address: _this.customerAddress.val(),
      Address2: _this.customerAddress2.val(),
      PostCode: _this.customerZipCode.val(),
      City: _this.customerCity.val(),
      Country: _this.customerCountry.val(),
      Mobile: _this.customerPhone2.val()
    });


    $.ajax({
      url: "/Cashier/UpdateCustomer",
      type: 'POST',
      data: data,
      error: function () {
        _this.btnModalMsg.fadeIn();
      },
      success: function (data) {
        if (data.status == "OK") {
          // Sätt kunddata i lista och sök
          $(_this.searchCustomerNr).val(data.customerId);
          _this._search();
          _this.modalAddCustomer.hide();
          _this.editCustomerId = 0;
        } else {
          if (data.status == "ERROR_MAIL_NOT_FREE") {
             //
            _this.btnModalMsg.fadeIn();
          } else {
            _this.btnModalMsg.fadeIn();
          }
        }
      }
    });
  }

  // CANCEL //
  _btnCustomerModalCancel() {
    this.editCustomerId = 0;
    this.modalAddCustomer.hide();
  }

  //
  // CREATE MODAL ///////////////////////////////
  //


  _btnCreateNewCustomer() {

    this.customerFirstname.val('');
    this.customerLastname.val('');
    this.customerEmail.val('');
    this.customerPhone.val('');
    this.customerAddress.val('');
    this.customerAddress2.val('');
    this.customerZipCode.val('');
    this.customerCity.val('');
    this.customerCountry.val('');
    this.customerPhone2.val('');

    this.modalTitle[0].innerText = "SKAPA NY KUND";

    this.btnModalMsg.hide();
    this.btnModalEditSubmit.hide();
    this.btnModalSubmit.show();
    this.pnlModalUserExist.hide();

    this.modalAddCustomer.show();
  }


  _btnCustomerModalSubmit() {
    this.btnModalEditSubmit.hide();
    this.btnModalSubmit.show();
    this.btnModalMsg.hide();
    this.pnlModalUserExist.hide();

    var _this = this;
    var data = jQuery.param({
      Firstname:  _this.customerFirstname.val(),
      Lastname:   _this.customerLastname.val(),
      Email:      _this.customerEmail.val(),
      Phone:      _this.customerPhone.val(),
      Address:    _this.customerAddress.val(),
      Address2:   _this.customerAddress2.val(),
      PostCode:    _this.customerZipCode.val(),
      City:       _this.customerCity.val(),
      Country:    _this.customerCountry.val(),
      Mobile:     _this.customerPhone2.val()

    });


    $.ajax({
      url: "/Cashier/AddCustomer",
      type: 'POST',
      data: data,
      error: function () {
        _this.btnModalMsg.fadeIn();
      },
      success: function (data) {
        if (data.status=="OK") {
          // Sätt kunddata i lista och sök
          $(_this.searchCustomerNr).val(data.customerId);
          _this._search();
          _this.modalAddCustomer.hide();
        } else {
          if (data.status == "ERROR_CUSTOMER_EXIST") {
            _this.pnlModalUserExist.fadeIn();
          } else {
            _this.btnModalMsg.fadeIn();
          }
        }
      }
    });


  }

  _btnCustomerModalExistSearch() {
    this.searchFirstname.val('');
    this.searchLastname.val('');
    this.searchCustomerNr.val('');
    this.searchPhone.val('');
    this.searchEmail.val(this.customerEmail.val());
    this._search();
    this.modalAddCustomer.hide();
  }

}